// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {ShelfItem} from './ShelfItem';


//COMPONENT
class Shelf extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            shelf: {},
            selectedProduct: {},
            selectedShelf: {},
            availableSpace: 0,
            availableSlots: 0,
            isSelectable: false,
            items: [],
            previewImages: {},
            usableDimensions: {}
        };

        this.getAvailableSlots = this.getAvailableSlots.bind(this);
        this.updateAvailableSpace = this.updateAvailableSpace.bind(this);
        this.shelfSelected = this.shelfSelected.bind(this);
        this.isShelfSelectable = this.isShelfSelectable.bind(this);
        this.getPercentage = this.getPercentage.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount(){
        this.setState({
            shelf: this.props.shelf
        });
        this.updateDimensions();
    }

    updateDimensions(){
        if(this.props.shelf['fillable-dimensions'] != undefined && this.props.shelf['fillable-dimensions'] != null){
            this.setState({
                usableDimensions: this.props.shelf['fillable-dimensions'],
                availableSpace: this.props.shelf['fillable-dimensions'].width
            });
        } else {
            this.setState({
                usableDimensions: this.props.shelf.dimensions,
                availableSpace: this.props.shelf.dimensions.width
            });
        }
    }

    updateAvailableSpace(items){
        if(items != undefined){
            let used = 0;
            for(let product of items){
                used += product.dimensions.width;
            }

            let availableSpace = this.state.usableDimensions.width - used;
            this.setState({availableSpace: availableSpace});
        } else {
            this.setState({availableSpace: this.usableDimensions.width});
        }
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(this.props.shelf) != JSON.stringify(prevProps.shelf)){
            this.setState({shelf: this.props.shelf});

            if(this.props.shelf.items != undefined){
                this.setState({items: this.props.shelf.items});
            }
            
            this.updateDimensions();
            this.updateAvailableSpace(this.props.shelf.items);
            this.isShelfSelectable(this.props.selectedShelf, this.props.selectedProduct);
        }

        if(JSON.stringify(this.props.selectedShelf) != JSON.stringify(prevProps.selectedShelf)){
            
            this.setState({selectedShelf: this.props.selectedShelf});
            this.isShelfSelectable(this.props.selectedShelf, this.props.selectedProduct);
        }

        if(this.props.selectedProduct != prevProps.selectedProduct){
            this.setState({selectedProduct: this.props.selectedProduct});

            if(JSON.stringify(this.props.selectedProduct) != JSON.stringify({}) && this.props.selectedProduct != undefined){
                let slots = this.getAvailableSlots(this.props.selectedProduct);
                this.setState({availableSlots: slots});
                this.isShelfSelectable(this.props.selectedShelf, this.props.selectedProduct, slots);
            } else {
                this.isShelfSelectable(this.props.selectedShelf, this.props.selectedProduct, this.state.availableSlots);
            }
        }
    }

    getAvailableSlots(product){
        let slots = Math.floor(this.state.availableSpace / product.dimensions.width);
        return slots;
    }

    isShelfSelectable(selectedShelf, selectedProduct, slots){
        if(JSON.stringify(selectedShelf) != JSON.stringify({})){
            this.setState({isSelectable: selectedShelf == this.state.shelf});
        } else {
            this.setState({isSelectable: JSON.stringify(selectedProduct) != JSON.stringify({}) && slots > 0});
        }
    }

    shelfSelected(){
        if(this.state.isSelectable){
            this.props.shelfSelected(this.state.shelf);
            this.props.avialbleSlotsForProduct(this.state.availableSlots);
        }
    }

    getPercentage(item){
        let percentage = String((item.dimensions.width / this.state.usableDimensions.width) * 100) + '%';
        return percentage;
    }

    render() {
        let count = 0;
        return (
            <div>
                <div>Shelf {this.state.shelf.order}</div>
                <div onClick={this.shelfSelected} className={'shelf ' + ((this.state.isSelectable) ? 'selectable' : 'unselectable')}>
                    {this.state.items.map((item) => {
                        return(
                            <div key={item.id + count++} className="product-in-shelf-container" style={{width: this.getPercentage(item)}}>
                                <ShelfItem item={item}/>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

Shelf.propTypes = {
    history: PropTypes.object.isRequired,
    shelf: PropTypes.object.isRequired,
    selectedShelf: PropTypes.object.isRequired,
    selectedProduct: PropTypes.object.isRequired,
    avialbleSlotsForProduct: PropTypes.func.isRequired,
    shelfSelected: PropTypes.func.isRequired
};

const hoc = withRouter(Shelf);

// EXPORT COMPONENT
export { hoc as Shelf };


// WEBPACK FOOTER //
// ./src/components/pages/Planograms/Shelf.js